import React, { PureComponent } from 'react';

/**
 * This class holds ann the common SVG definitions for load bars.
 *
 * Repeating all those definitions in every SVG element was making the DOM way too big, which had a nasty impact of performance.
 * Instead, SVG definitions are now all grouped in one single React component, and is rendered only once.
 */
export class SvgCommonDefs extends PureComponent {
    render() {
        return (
            <svg id="svg-common-definitions" style={{ position: 'absolute', width: 0 }}>
                <defs>
                    <linearGradient id="normal">
                        <stop stopColor="#303030" />
                    </linearGradient>
                    <linearGradient id="low-threshold">
                        <stop stopColor="#726648" />
                    </linearGradient>
                    <linearGradient id="high-threshold">
                        <stop stopColor="#CC9933" />
                    </linearGradient>
                    <linearGradient id="overload">
                        <stop stopColor="#FF0000" />
                    </linearGradient>

                    <pattern
                        id="normal-hashed"
                        width="5"
                        height="10"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45 0 0)">
                        <rect width="100%" height="100%" fill="#262626"></rect>
                        <line stroke="#303030" strokeWidth="5" y2="10"></line>
                    </pattern>
                    <pattern
                        id="low-threshold-hashed"
                        width="5"
                        height="10"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45 0 0)">
                        <rect width="100%" height="100%" fill="#262626"></rect>
                        <line stroke="#726648" strokeWidth="5" y2="10"></line>
                    </pattern>
                    <pattern
                        id="high-threshold-hashed"
                        width="5"
                        height="10"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45 0 0)">
                        <rect width="100%" height="100%" fill="#262626"></rect>
                        <line stroke="#CC9933" strokeWidth="5" y2="10"></line>
                    </pattern>
                    <pattern
                        id="overload-hashed"
                        width="5"
                        height="10"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45 0 0)">
                        <rect width="100%" height="100%" fill="#262626"></rect>
                        <line stroke="#FF0000" strokeWidth="5" y2="10"></line>
                    </pattern>
                </defs>
            </svg>
        );
    }
}
